module.exports = __webpack_public_path__ + "img/close.ff736e12.png";